import { Component, Input } from '@angular/core';

@Component({
  selector: 'kpi-rectangle',
  templateUrl: './kpi-rectangle.component.html',
  styleUrls: ['./kpi-rectangle.component.scss']
})
export class KpiRectangleComponent {
  @Input() title: string;
  @Input() value1: string;
  @Input() label1: string;
  @Input() value2: string;
  @Input() label2: string;
  @Input() value3: string;
  @Input() label3: string;
  @Input() value4: string;
  @Input() label4: string;
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/kpi-rectangle/kpi-rectangle.component.ts